import { ModulesType } from 'components/filter/models/TableFilterModels';
import alb from 'services/api/alb';
import apiPython from 'services/api/apiPython';
interface IRequestBody {
	column_name: string;
	search: string;
	size: number;
	page: number;
	[key: string]: any;
}
export const fetchByFiltersDependency = async (
	body: IRequestBody,
	module: ModulesType,
	editable = false
) => {
	const isExceptions =
		module === 'oportunidade' && body.ciclo_id && body.date;

	const url = isExceptions
		? `/${module}/view/filter/exceptions`
		: `/${module}/${editable ? 'editable-view-filter' : 'view/filter'}`;

	const response = await alb.post(url, body);
	return response.data;
};

export const fetchByFiltersDependencyFromExternalAPI = async body => {
	const url = '/accuracy/additional/filter';

	const { column_name: column, page, size, search, ...others } = body;

	const response = await apiPython.get(url, {
		params: {
			column,
			search,
			page,
			size,
			...others,
		},
	});
	return response.data;
};
